import { connect } from 'react-redux';
import TimelineListViewRow from './TimelineListViewRow';
import { toggleTimelineItem } from '../../../modules/Timeline/actions';

const mapDispatchToProps = {
  onToggle: toggleTimelineItem,
};

export default connect(null, mapDispatchToProps)(TimelineListViewRow);
